<template>
    <div>
        <template v-if="enquiriesLoading">
            <h1><div class="count-blinker"></div> henvendelser</h1>
        </template>
        <template v-else-if="enquiries && enquiries.length > 0">
            <h1>{{ enquiries[0].rowCount }} henvendelse<template v-if="enquiries[0].rowCount > 1">r</template></h1>
        </template>
        <template v-else>
            <h1>Ingen henvendelser</h1>
        </template>

        <div class="list-filter" v-if="activeFilters">
            <div class="list-filter-group">
                <template v-if="supplyTypes && supplyTypes.length > 1">
                    <div class="list-filter-item" v-for="supplyType in supplyTypes" :key="supplyType.sysBusinessAreaTypeId" v-if="getFilters.supplyType.includes(supplyType.sysBusinessAreaTypeId)" :class="'list-filter-item--' + supplyType.systemName">
                        <span class="list-filter-item-label">Forretningsområde:</span><span class="list-filter-item-value"><icon class="tiny-svg" :name="supplyType.systemName" />{{ supplyType.description }}</span>
                        <button class="list-filter-item-button" @click="removeSupplyTypeFilter(supplyType.sysBusinessAreaTypeId)">
                            <span class="visually-hidden">Fjern filter</span>
                            <span aria-hidden="true">&#10761;</span>
                        </button>
                    </div>
                </template>

                <div class="list-filter-item" v-if="getFilters.address">
                    <span class="list-filter-item-label">Adresse:</span><span class="list-filter-item-value">{{ getFilters.address }}</span>
                    <button class="list-filter-item-button" @click="removeAddressFilter()">
                        <span class="visually-hidden">Fjern filter</span>
                        <span aria-hidden="true">&#10761;</span>
                    </button>
                </div>

                <div class="list-filter-item list-filter-item--alert" v-if="getFilters.kpi === 'enquiriesNoResponsible'">
                    <span class="list-filter-item-value">Henvendelser uden ansvarlig</span>
                    <button class="list-filter-item-button" @click="removeKPIFilter()">
                        <span class="visually-hidden">Fjern filter</span>
                        <span aria-hidden="true">&#10761;</span>
                    </button>
                </div>

                <div class="list-filter-item" v-if="getFilters.enquiries.showClosed">
                    <span class="list-filter-item-label">Status:</span><span class="list-filter-item-value">Vis også afsluttede</span>
                    <button class="list-filter-item-button" @click="removeEnquiryFilter('showClosed')">
                        <span class="visually-hidden">Fjern filter</span>
                        <span aria-hidden="true">&#10761;</span>
                    </button>
                </div>

                <div class="list-filter-item" v-for="responsible in getFilters.enquiries.responsible" :key="responsible">
                    <span class="list-filter-item-label">Ansvarlig:</span><span class="list-filter-item-value">{{ caseworkers.find(item => item.userId === responsible).name }}</span>
                    <button class="list-filter-item-button" @click="removeEnquiryFilter('responsible', responsible)">
                        <span class="visually-hidden">Fjern filter</span>
                        <span aria-hidden="true">&#10761;</span>
                    </button>
                </div>

                <div class="list-filter-item" v-for="problemType in getFilters.enquiries.problemType" :key="problemType">
                    <span class="list-filter-item-label">Problemtype:</span><span class="list-filter-item-value">{{ problemTypesList.find(item => item.id === problemType).area }}, {{ problemTypesList.find(item => item.id === problemType).name }}</span>
                    <button class="list-filter-item-button" @click="removeEnquiryFilter('problemType', problemType)">
                        <span class="visually-hidden">Fjern filter</span>
                        <span aria-hidden="true">&#10761;</span>
                    </button>
                </div>

                <div class="list-filter-item" v-for="contactType in getFilters.enquiries.contactType" :key="contactType">
                    <span class="list-filter-item-label">Kontakttype:</span><span class="list-filter-item-value">{{ contactTypesList.find(item => item.id === contactType).area }}, {{ contactTypesList.find(item => item.id === contactType).name }}</span>
                    <button class="list-filter-item-button" @click="removeEnquiryFilter('contactType', contactType)">
                        <span class="visually-hidden">Fjern filter</span>
                        <span aria-hidden="true">&#10761;</span>
                    </button>
                </div>

                <div class="list-filter-item" v-if="getFilters.enquiries.createdDate.from || getFilters.enquiries.createdDate.to">
                    <span class="list-filter-item-label">Hændelsesdato<template v-if="getFilters.enquiries.createdDate.from && !getFilters.enquiries.createdDate.to"> efter</template><template v-if="!getFilters.enquiries.createdDate.from && getFilters.enquiries.createdDate.to"> før</template>:</span>
                    <span class="list-filter-item-value">
                        <template v-if="getFilters.enquiries.createdDate.from && getFilters.enquiries.createdDate.to">
                            {{ getFilters.enquiries.createdDate.from | formatDateShort }} - {{ getFilters.enquiries.createdDate.to | formatDateShort }}
                        </template>
                        <template v-if="getFilters.enquiries.createdDate.from && !getFilters.enquiries.createdDate.to">
                            {{ getFilters.enquiries.createdDate.from | formatDateShort }}
                        </template>
                        <template v-if="!getFilters.enquiries.createdDate.from && getFilters.enquiries.createdDate.to">
                            {{ getFilters.enquiries.createdDate.to | formatDateShort }}
                        </template>
                    </span>
                    <button class="list-filter-item-button" @click="removeEnquiryFilter('createdDate', getFilters.enquiries.createdDate.from || getFilters.enquiries.createdDate.to)">
                        <span class="visually-hidden">Fjern filter</span>
                        <span aria-hidden="true">&#10761;</span>
                    </button>
                </div>
            </div>
        </div>

        <pagination v-show="enquiries && enquiries.length > 0 && enquiries[0].pageCount > 1 && !enquiriesLoading" :showPaging="enquiries && enquiries.length > 0 && enquiries[0].pageCount > 1 ? true : false" :totalPages="enquiries && enquiries.length > 0 ? enquiries[0].pageCount : null" :page="'enquiries'" :position="'right'" />
        <div v-if="enquiries && enquiries.length > 0 && !enquiriesLoading" class="grid-x list-sort" style="margin-right: 36px;">
            <div class="cell large-1"></div>
            <div class="cell large-2">
                <button :aria-selected="currentSort === 'address1'" @click="sort('address1')">Adresse<icon v-if="currentSort === 'address1'" class="small-svg fill-selected-dark-gray" :class="{rotated: !currentSortDir && currentSort === 'address1'}" name="keyboard_arrow_sort" /></button>
            </div>
            <div class="cell large-2">
                <button :aria-selected="currentSort === 'problemType'" @click="sort('problemType')">Problemtype<icon v-if="currentSort === 'problemType'" class="small-svg fill-selected-dark-gray" :class="{rotated: !currentSortDir && currentSort === 'problemType'}" name="keyboard_arrow_sort" /></button>
            </div>
            <div class="cell large-2">
                <button :aria-selected="currentSort === 'occurrenceDateTime'" @click="sort('occurrenceDateTime')">Hændelsesdato<icon v-if="currentSort === 'occurrenceDateTime'" class="small-svg fill-selected-dark-gray" :class="{rotated: !currentSortDir && currentSort === 'occurrenceDateTime'}" name="keyboard_arrow_sort" /></button>
            </div>
            <div class="cell large-2">
                <button :aria-selected="currentSort === 'receivedByUser'" @click="sort('receivedByUser')">Oprettet af<icon v-if="currentSort === 'receivedByUser'" class="small-svg fill-selected-dark-gray" :class="{rotated: !currentSortDir && currentSort === 'receivedByUser'}" name="keyboard_arrow_sort" /></button>
            </div>
            <div class="cell large-2">
                <button :aria-selected="currentSort === 'ownerUser'" @click="sort('ownerUser')">Ansvarlig<icon v-if="currentSort === 'ownerUser'" class="small-svg fill-selected-dark-gray" :class="{rotated: !currentSortDir && currentSort === 'ownerUser'}" name="keyboard_arrow_sort" /></button>
            </div>
            <div class="cell large-1">
                <button :aria-selected="currentSort === 'requestStatus'" @click="sort('requestStatus')">Status<icon v-if="currentSort === 'requestStatus'" class="small-svg fill-selected-dark-gray" :class="{rotated: !currentSortDir && currentSort === 'requestStatus'}" name="keyboard_arrow_sort" /></button>
            </div>
        </div>
        <transition-group name="list" tag="div" v-if="!enquiriesLoading">
            <div class="grid-x list-row supply align-items" :class="businessAreaClass(enquiry.businessAreaTypeId)" style="margin-right: 36px;" v-for="enquiry in enquiries" :key="enquiry.requestId">
                <div class="cell large-1">
                    <icon class="medium-svg fill-primary" name="enquiry" />
                </div>
                <div class="cell large-2 item truncate-fade">
                    <span v-if="enquiry.address1">{{ enquiry.address1 }}<span v-if="enquiry.address2">, {{ enquiry.address2 }},</span> {{ enquiry.postalCode }} {{ enquiry.city }}</span>
                    <span v-else>Ingen adresse</span>
                    <span v-if="enquiry.clientName">{{ enquiry.clientName }}</span>
                    <span v-else>Intet navn på anmelder</span>
                </div>
                <div class="cell large-2 item truncate-fade">
                    <span v-if="enquiry.problemType">{{ enquiry.problemType }}</span>
                    <span v-else>Ingen problemtype</span>
                    <span v-if="enquiry.description">{{ enquiry.description }}</span>
                    <span v-else>Ingen beskrivelse</span>
                </div>
                <div v-if="enquiry.occurrenceDateTime" class="cell large-2 item truncate-fade">
                    <span>{{ enquiry.occurrenceDateTime | formatDateShortElapsed }}</span>
                    <!-- <span>{{ enquiry.occurrenceDateTime | formatTime }}</span> -->
                </div>
                <div v-else class="cell large-2 item list-one-row truncate-fade">
                    <span>Ingen dato</span>
                </div>
                <div class="cell large-2 item truncate-fade">
                    <span>{{ enquiry.receivedByUser }}</span>
                    <span>{{ enquiry.receivedByOrganization }}</span>
                </div>
                <div v-if="enquiry.ownerUser" class="cell large-2 item truncate-fade">
                    <span>{{ enquiry.ownerUser }}</span>
                    <span v-if="!enquiry.ownerActive"><em>Inaktiv bruger</em></span>
                    <span v-else>{{ enquiry.ownerOrganization }}</span>
                </div>
                <div v-else class="cell large-2 item list-one-row truncate-fade">
                    <span>Ingen ansvarlig</span>
                </div>
                <div class="cell large-1 item flexbox-center">
                    <div class="enquiry-status red-status" v-if="enquiry.ownerUserId === null">Ingen ansvarlig</div>
                    <div class="enquiry-status" v-else :class="statusColor(enquiry.requestStatus)">{{ enquiry.requestStatus }}</div>
                </div>
                <router-link class="dashboard-list-link" :to="{ name: 'enquiryid', params: { id: enquiry.requestId } }">
                    <span class="visually-hidden">Åben henvendelse</span>
                </router-link>
                <div class="dashboard-list-options" v-clickoutside="enquiryOptionsHide">
                    <button type="button" @click="enquiryOptionsToggle(enquiry.requestId)">
                        <icon class="small-svg fill-primary" name="settings" />
                        <span class="visually-hidden">Vis redigeringsmuligheder</span>
                    </button>
                    <ul v-if="showEnquiryOptions === enquiry.requestId" class="base-node__options base-node__options--visible">
                        <li><button type="button" @click="enquiryCopy(enquiry.requestId)">Kopier henvendelse</button></li>
                    </ul>
                </div>
            </div>
        </transition-group>
        <pagination v-show="enquiries && enquiries.length > 0 && enquiries[0].pageCount > 1 && !enquiriesLoading" :showPaging="enquiries && enquiries.length > 0 && enquiries[0].pageCount > 1 ? true : false" :totalPages="enquiries && enquiries.length > 0 ? enquiries[0].pageCount : null" :page="'enquiries'" :position="'right'" />

        <div class="dashboard-list-empty" v-if="!enquiriesLoading && enquiries && enquiries.length === 0">
            <template v-if="activeFilters">
                <h2>Ingen henvendelser, prøv at ændre en af følgende ting:</h2>
                <ul>
                    <li v-if="getFilters.supplyType.length < supplyTypes.length">Vælg et andet forretningsområde</li>
                    <li v-if="getFilters.enquiries.responsible.length > 1">Vælg en anden ansvarlig</li>
                    <li v-if="getFilters.address">Fjern søgning efter adresse</li>
                    <li>Fjern et eller flere filtre</li>
                </ul>
            </template>
            <template v-else>
                <p><em>Ingen henvendelser oprettet endnu...</em></p>
            </template>
        </div>

        <div class="text-center dashboard-list-loading" v-if="enquiriesLoading || !enquiries">
            Indlæser henvendelser...
            <div class="list-loader">
                <div class="bar"></div>
                <div class="bar"></div>
                <div class="bar"></div>
                <div class="visually-hidden">Indlæser...</div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import pagination from './../../../components/shared/pagination/pagination.vue'
import clickoutside from './../../../mixins/shared/clickoutside.js'

export default {
    name: 'list-enquiries',
    directives: {
        clickoutside
    },
    components: {
        pagination
    },
    props: {
        value: Array
    },
    data () {
        return {
            enquiries: this.value,
            showEnquiryOptions: false
        }
    },
    computed: {
        ...mapGetters({
            currentSortDir: 'getCurrentEnquiryOrderByDescending',
            currentSort: 'getCurrentEnquiryOrderByColumnName',

            enquiriesLoading: 'getEnquiriesLoading',

            // Filters
            supplyTypes: 'getBusinessAreaTypes',
            caseworkers: 'caseWorkerList',
            problemTypes: 'getProblemTypes',
            contactTypes: 'getCClientTypeList',
            getFilters: 'getFilters'
        }),

        contactTypesList () {
            const contactTypeList = []

            this.supplyTypes.forEach((supplyType) => {
                Object.values(this.contactTypes).find(value => value && value.businessAreaTypeId === supplyType.sysBusinessAreaTypeId).codeList.forEach((contactType) => {
                    contactTypeList.push({
                        id: contactType.typeId,
                        name: contactType.description,
                        area: supplyType.description
                    })
                })
            })

            return contactTypeList
        },
        problemTypesList () {
            const problemTypeList = []

            this.supplyTypes.forEach((supplyType) => {
                Object.values(this.problemTypes).find(value => value && value.businessAreaTypeId === supplyType.sysBusinessAreaTypeId).codeList.forEach((problemType) => {
                    problemTypeList.push({
                        id: problemType.typeId,
                        name: problemType.description,
                        area: supplyType.description
                    })
                })
            })

            return problemTypeList
        },
        activeFilters () {
            if (this.getFilters.kpi === 'enquiriesNoResponsible' || this.supplyTypes.length > 1 || this.getFilters.address || this.getFilters.enquiries.showClosed || (this.getFilters.enquiries.responsible && this.getFilters.enquiries.responsible.length > 0) || this.getFilters.enquiries.createdDate.from || this.getFilters.enquiries.createdDate.to || (this.getFilters.enquiries.problemType && this.getFilters.enquiries.problemType.length > 0) || (this.getFilters.enquiries.contactType && this.getFilters.enquiries.contactType.length > 0)) {
                return true
            }

            return false
        }
    },
    watch: {
        value (enquiries) {
            this.enquiries = enquiries
        },

        getFilters: {
            deep: true,
            handler () {
                this.getFilteredList()
            }
        }
    },
    methods: {
        ...mapActions({
            getEnquiries: 'getQueryRequestList',
            setActivePages: 'setActivePages',
            removeFilters: 'removeFilters',
            resetFilters: 'resetFilters',
            getEnquiry: 'getEnquiry',
            saveEnquiry: 'createUpdateEnquiry'
        }),

        sort (property) {
            const filterObject = {
                orderByDescending: this.currentSort !== property ? false : this.currentSortDir = !this.currentSortDir,
                orderByColumnName: property,
                tab: 'requests',
                page: 1
            }

            this.setActivePages(filterObject)
        },
        businessAreaClass (businessAreaType) {
            return this.supplyTypes.find(supplyType => supplyType.sysBusinessAreaTypeId === businessAreaType).systemName
        },
        statusColor (status) {
            if (status) {
                if (status.toLowerCase() === 'oprettet') {
                    return 'blue-status'
                }
                if (status.toLowerCase() === 'drifttiltag besluttet') {
                    return 'green-status'
                }
                if (status.toLowerCase() === 'afsluttet') {
                    return 'gray-status'
                }
                if (status.toLowerCase() === 'afvist - vedrører ikke forsyningen') {
                    return 'gray-status'
                }
            }
            return 'blue-status'
        },
        getFilteredList () {
            const filter = this.getFilters.enquiries
            const enquiryQuery = {}

            if (filter.showClosed) {
                enquiryQuery.whereIsClosed = filter.showClosed
            }
            if (filter.responsible) {
                enquiryQuery.whereOwnerUserIdList = filter.responsible
            }
            if (filter.createdDate.from) {
                enquiryQuery.whereFromDate = filter.createdDate.from
            }
            if (filter.createdDate.to) {
                enquiryQuery.whereToDate = filter.createdDate.to
            }
            if (filter.problemType) {
                enquiryQuery.whereProblemTypeIdList = filter.problemType
            }
            if (filter.contactType) {
                enquiryQuery.whereClientTypeIdList = filter.contactType
            }

            if (this.getFilters.kpi) {
                enquiryQuery.kpiFilter = this.getFilters.kpi
            }

            if (this.getFilters.supplyType) {
                enquiryQuery.whereBusinessAreaTypeIdList = this.getFilters.supplyType
            }

            if (this.getFilters.address) {
                enquiryQuery.whereLikeOccurrenceAddress = this.getFilters.address
            }

            this.getEnquiries(enquiryQuery)
        },
        removeSupplyTypeFilter (value) {
            if (this.getFilters.supplyType.length === 1) {
                this.$notify({
                    group: 'info',
                    type: 'warn',
                    text: 'Der skal være valgt minimum et forretningsområde.',
                    duration: 7500
                })
                return
            }

            this.removeFilters({
                filter: 'supplyType',
                value: value
            })
        },
        removeAddressFilter () {
            this.removeFilters({
                filter: 'address',
                value: ''
            })
        },
        removeKPIFilter () {
            this.resetFilters('user')
        },
        removeEnquiryFilter (filter, value) {
            if (Array.isArray(this.getFilters.enquiries[filter]) && filter === 'responsible') {
                const element = this.$parent.$children.find(child => child.$options.name === 'dashboard-filters').$refs[`enquiry${filter[0].toUpperCase() + filter.slice(1)}`]

                if (element) {
                    element.checked = element.checked.filter(item => item.userId !== value)
                }
            }
            this.removeFilters({
                page: 'enquiries',
                filter: filter,
                value: value
            })
        },
        enquiryOptionsShow (enquiryId) {
            this.showEnquiryOptions = enquiryId
        },
        enquiryOptionsHide (event) {
            if (event && event.target.closest('.dashboard-list-options')) {
                return
            }
            this.showEnquiryOptions = false
        },
        enquiryOptionsToggle (enquiryId) {
            if (this.showEnquiryOptions === enquiryId) {
                this.enquiryOptionsHide()
            } else {
                this.enquiryOptionsShow(enquiryId)
            }
        },
        enquiryCopy (enquiryId) {
            // Use ID from copied enquiry
            this.$router.push({
                name: 'enquiry',
                query: {
                    // id: enquiry.requestId
                    copy: enquiryId
                }
            })
        }
    },
    mounted () {
        this.getFilteredList()
    }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/list/list-enquiries.vue